(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECKOUT_URL = ROOT + 'checkout';
  var OFFERS_URL = '/pages/nos-offres';
  var ACCOUNT_URL = '/pages/compte';
  var STRIPE_TAG = 'stripe'; // clientes encore sur l'ancien système : libres de passer sur Recharge
  var LOCK_TIMEOUT = 15000; // ms — le verrou tombe seul si une requête ne répond jamais

  // ------------------------------------------------------------ verrou
  var inFlight = false;
  var lockTimer = null;

  function lock() {
    if (inFlight) return false;
    inFlight = true;
    clearTimeout(lockTimer);
    lockTimer = setTimeout(unlock, LOCK_TIMEOUT);
    return true;
  }

  function unlock() {
    inFlight = false;
    clearTimeout(lockTimer);
    lockTimer = null;
  }

  // Retour arrière depuis le checkout : le navigateur peut restaurer la page
  // telle quelle (bfcache), verrou et boutons occupés compris.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      unlock();
      setBusy(Array.prototype.slice.call(document.querySelectorAll('[data-sub-guard-busy]')), false);
    }
  });

  // ------------------------------------------------------------ boutons
  function submitButtonsOf(form) {
    return Array.prototype.filter.call(form.elements, function (el) {
      return el.type === 'submit';
    });
  }

  function setBusy(buttons, busy) {
    buttons.forEach(function (btn) {
      if (busy) {
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('data-sub-guard-busy', '');
      } else {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('data-sub-guard-busy');
      }
    });
  }

  // ------------------------------------------------------------ popup
  var FIRST_ORDER_USED = {
    title: 'Offre déjà utilisée',
    body: 'Tu as déjà bénéficié de l\'abonnement gratuit. Pour continuer à accéder au Wellness Club, choisis l\'une de nos offres payantes.',
    button: 'Voir les offres',
    href: OFFERS_URL
  };

  var ALREADY_SUBSCRIBED = {
    title: 'Abonnement déjà actif',
    body: 'Tu as déjà un abonnement en cours, et un compte ne peut en avoir qu\'un seul à la fois. Tu peux le retrouver et le gérer depuis ton compte.',
    button: 'Mon compte',
    href: ACCOUNT_URL
  };

  function showPopup(content) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:99999;display:flex;align-items:center;justify-content:center;padding:1rem;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;color:#111;border-radius:8px;padding:2rem 2rem 1.5rem;max-width:420px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.25);';

    var title = document.createElement('p');
    title.style.cssText = 'font-size:1.1rem;font-weight:700;margin:0 0 .75rem;';
    title.textContent = content.title;

    var body = document.createElement('p');
    body.style.cssText = 'font-size:.9rem;line-height:1.55;margin:0 0 1.5rem;opacity:.75;';
    body.textContent = content.body;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.style.cssText = 'background:#111;color:#fff;border:none;border-radius:4px;padding:.7rem 1.75rem;font-size:.875rem;font-weight:600;cursor:pointer;';
    btn.textContent = content.button;

    btn.addEventListener('click', function () {
      window.location.href = content.href;
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) document.body.removeChild(overlay);
    });

    modal.appendChild(title);
    modal.appendChild(body);
    modal.appendChild(btn);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  // ------------------------------------------------------------ API panier
  function cartRequest(path, body) {
    var options = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(ROOT + path, options).then(function (res) {
      if (!res.ok) throw new Error('[subscription-guard] ' + path + ' → HTTP ' + res.status);
      return res.json();
    });
  }

  function getCart() {
    return cartRequest('cart.js');
  }

  // updates : { <line_item.key>: <quantité> } — 0 retire la ligne
  function updateCart(updates) {
    return cartRequest('cart/update.js', { updates: updates });
  }

  function addSubscription(variantId, planId) {
    return cartRequest('cart/add.js', {
      items: [{ id: variantId, quantity: 1, selling_plan: planId }]
    });
  }

  // ------------------------------------------------------------ cliente connectée
  function customerTags() {
    return Array.isArray(window.__customerTags) ? window.__customerTags : [];
  }

  function hasTag(name) {
    name = name.toLowerCase();
    return customerTags().some(function (tag) {
      return String(tag).trim().toLowerCase() === name;
    });
  }

  // Cliente connectée dont custom.end_date_subscription est aujourd'hui ou dans
  // le futur (date incluse — même règle que les sections compte / cours), sauf
  // ancien système Stripe. Déconnectée ou sans métachamp → false.
  function hasActiveSubscription() {
    if (!Array.isArray(window.__customerTags)) return false; // pas connectée
    if (hasTag(STRIPE_TAG)) return false;

    var raw = window.__customerSubEnd;
    if (typeof raw !== 'string') return false;
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw.trim());
    if (!m) return false;

    var endOfDay = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59, 999);
    return !isNaN(endOfDay.getTime()) && endOfDay.getTime() >= Date.now();
  }

  // ------------------------------------------------------------ abonnements
  function isSubscription(item) {
    return !!item.selling_plan_allocation;
  }

  function sameSubscription(item, variantId, planId) {
    return item.variant_id === variantId &&
      !!item.selling_plan_allocation &&
      !!item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.id === planId;
  }

  // Prix unitaire réellement facturé sur cette commande (après remises)
  function unitPrice(item) {
    return typeof item.final_price === 'number' ? item.final_price : item.price;
  }

  // Filet final : une seule ligne d'abonnement (la moins chère), en quantité 1.
  // À prix égal, la ligne la plus ancienne du panier est gardée.
  async function enforceSingleSubscription(cart) {
    var subs = cart.items.filter(isSubscription);
    if (subs.length === 0) return cart;

    var keep = subs[0];
    subs.forEach(function (item) {
      if (unitPrice(item) < unitPrice(keep)) keep = item;
    });

    var updates = {};
    subs.forEach(function (item) {
      if (item !== keep) updates[item.key] = 0;
    });
    if (keep.quantity !== 1) updates[keep.key] = 1;

    if (Object.keys(updates).length === 0) return cart;
    return updateCart(updates);
  }

  async function enforceBeforeCheckout() {
    try {
      await enforceSingleSubscription(await getCart());
    } catch (_) {
      // Réseau indisponible : on laisse partir, le cron Recharge rattrape un éventuel doublon
    }
  }

  // ------------------------------------------------------------ parcours produit
  // Retourne 'redirect' (départ vers le checkout), 'blocked' (popup affichée)
  // ou 'fallback' (ajout refusé par Shopify → on rend la main à ProductForm).
  async function processSubscriptionAdd(variantId, planId) {
    // 0. Déjà abonnée : un seul abonnement par compte
    if (hasActiveSubscription()) {
      showPopup(ALREADY_SUBSCRIBED);
      return 'blocked';
    }

    // 1. Offre gratuite déjà consommée
    try {
      var tags = customerTags();
      if (tags.indexOf('Active Subscriber') !== -1 || tags.indexOf('Inactive Subscriber') !== -1) {
        var variantInfo = await fetch(ROOT + 'variants/' + variantId + '.js').then(function (r) { return r.json(); });
        if (variantInfo.price === 0) {
          showPopup(FIRST_ORDER_USED);
          return 'blocked';
        }
      }
    } catch (_) {}

    // 2. Ménage : les autres abonnements sortent, le plan cliqué repasse en quantité 1
    var alreadyInCart = false;
    try {
      var cart = await getCart();
      var updates = {};
      cart.items.forEach(function (item) {
        if (!isSubscription(item)) return;
        if (sameSubscription(item, variantId, planId)) {
          alreadyInCart = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length > 0) await updateCart(updates);
    } catch (_) {
      // Réseau : on tente quand même l'ajout, le filet final repassera derrière
    }

    // 3. Ajout du plan cliqué, toujours en quantité 1
    if (!alreadyInCart) {
      try {
        await addSubscription(variantId, planId);
      } catch (_) {
        return 'fallback';
      }
    }

    // 4. Filet final puis checkout
    await enforceBeforeCheckout();
    window.location.href = CHECKOUT_URL;
    return 'redirect';
  }

  function resubmitToProductForm(form) {
    form._subGuardPass = true;
    try {
      form.requestSubmit();
    } catch (_) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    setTimeout(function () { delete form._subGuardPass; }, 0);
  }

  function onProductFormSubmit(event, form) {
    var fd = new FormData(form);
    var sellingPlan = fd.get('selling_plan');

    // Achat unique : on n'intervient pas
    if (!sellingPlan) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Double-clic : un passage est déjà en cours
    if (!lock()) return;

    var variantId = parseInt(fd.get('id'), 10);
    var planId = parseInt(sellingPlan, 10);
    var buttons = submitButtonsOf(form);
    setBusy(buttons, true);

    processSubscriptionAdd(variantId, planId).then(function (outcome) {
      if (outcome === 'redirect') return; // la page part vers le checkout, on reste verrouillé
      setBusy(buttons, false);
      unlock();
      if (outcome === 'fallback') resubmitToProductForm(form);
    }, function () {
      setBusy(buttons, false);
      unlock();
      resubmitToProductForm(form);
    });
  }

  // ------------------------------------------------------------ parcours panier
  function isCartForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/cart\/?(?:[?#]|$)/.test(action);
  }

  function isCheckoutSubmit(event) {
    // Sans event.submitter (vieux navigateurs), le seul bouton de soumission
    // des formulaires panier du thème est « Commander »
    return event.submitter ? event.submitter.name === 'checkout' : true;
  }

  // Panier sans abonnement : rien à faire. Avec abonnement : cliente déjà abonnée
  // → départ bloqué (true) ; sinon filet « une seule ligne, la moins chère ».
  async function checkCartBeforeCheckout() {
    var cart;
    try {
      cart = await getCart();
    } catch (_) {
      return false; // Réseau indisponible : on laisse partir
    }
    if (!cart.items.some(isSubscription)) return false;
    if (hasActiveSubscription()) return true;
    try {
      await enforceSingleSubscription(cart);
    } catch (_) {}
    return false;
  }

  function onCartCheckoutSubmit(event, form) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (!lock()) return;

    var submitter = event.submitter || null;
    var buttons = submitter ? [submitter] : submitButtonsOf(form);
    setBusy(buttons, true);

    checkCartBeforeCheckout().then(function (blocked) {
      if (blocked) {
        setBusy(buttons, false);
        unlock();
        showPopup(ALREADY_SUBSCRIBED);
        return;
      }

      // Soumission native du formulaire (note, CGV…) avec le même bouton,
      // le guard la laisse passer grâce à _subGuardPass
      form._subGuardPass = true;
      try {
        if (submitter && form.requestSubmit) {
          form.requestSubmit(submitter);
        } else {
          window.location.href = CHECKOUT_URL;
        }
      } catch (_) {
        window.location.href = CHECKOUT_URL;
      }
      setTimeout(function () { delete form._subGuardPass; }, 0);

      // Si la page ne part pas (erreur, validation), tout redevient cliquable
      setTimeout(function () {
        setBusy(buttons, false);
        unlock();
      }, 3000);
    });
  }

  // ------------------------------------------------------------ dispatch
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    // Re-soumission déclenchée par le guard lui-même
    if (form._subGuardPass) return;

    if (form.closest('product-form')) {
      onProductFormSubmit(event, form);
    } else if (isCartForm(form) && isCheckoutSubmit(event)) {
      onCartCheckoutSubmit(event, form);
    }
  }, { capture: true });
})();